"use client";

import { Bell } from "lucide-react";
import dynamic from "next/dynamic";
import { useTranslations } from "next-intl";
import { useState } from "react";

import { useAuthStore } from "@/shared/model/auth-store";
import { Skeleton } from "@/shared/ui/data-display/skeleton";

const load = () => import("./notification-dropdown");
const NotificationDropdown = dynamic(
  () => load().then((m) => m.NotificationDropdown),
  { ssr: false, loading: () => <Skeleton className="h-10 w-10 rounded-full" /> },
);

/**
 * Колокольчик в хедере.
 *
 * KAN-975: настоящий виджет тянет четыре API-модуля со схемами и весь zod (350 КБ JS).
 * Анониму уведомления не приходят, поэтому до входа стоит кнопка-заглушка того же вида,
 * наведение и фокус только подгружают чанк виджета, а клик монтирует его уже открытым —
 * так нажатие не теряется, пока чанк в пути.
 */
export function NotificationBell() {
  const tUi = useTranslations("Ui");
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const [opened, setOpened] = useState(false);

  if (isAuthenticated || opened) {
    return <NotificationDropdown initialOpen={opened} />;
  }
  return (
    <button
      type="button"
      aria-label={tUi("litNotificationDropdown.uvedomleniya")}
      className="relative flex h-10 w-10 items-center justify-center rounded-lg transition-all duration-300 hover:bg-accent"
      onPointerEnter={() => void load()}
      onFocus={() => void load()}
      onClick={() => setOpened(true)}
    >
      <Bell className="h-6 w-6" />
    </button>
  );
}
